<template>
  <v-layout row align-center style="margin: 0;padding: 0;">
    <v-subheader>{{prop.text}}</v-subheader>
    <v-select color="primary" :items="['[','(']" v-model="lowSymbol" style="max-width: 20px" append-icon=""></v-select>
    <slot name="lower" :range="range">
      <v-text-field type="number" v-model="range.lower" label="下限" style="max-width: 100px;margin-left: 0px;">
      </v-text-field>
    </slot>
    <v-select color="error" append-icon="" flat readonly :items="[',','~','——']" v-model="rangeSymbol"
      style="max-width: 50px">
    </v-select>
    <slot name="upper" :range="range">
      <v-text-field type="number" v-model="range.upper" label="上限" style="max-width: 100px;text-align: right;">
      </v-text-field>
    </slot>
    <v-select append-icon="" :items="[']',')']" v-model="upperSymbol" style="max-width: 20px;"></v-select>
  </v-layout>
</template>

<style scoped>

</style>

<script>
  import RangeInput from "./rangeInput.ts";
  export default RangeInput;
</script>